export var NaNDocs = {
  name: 'NaN',
  category: 'Constants',
  syntax: ['NaN'],
  description: 'Not a number',
  examples: ['NaN', '0 / 0'],
  seealso: []
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/expression/embeddedDocs/constants/NaN.js
// module id = 1560
// module chunks = 0